<template>
  <div class="register-page-container">
    <div class="register-form-container">
      <!-- 表单内容保持不变 -->
      <h2 class="title">{{ t('修改密码') }}</h2>
      <div class="link-container">
        <span>{{ t('返回') }}</span>
        <el-link type="primary" :underline="false" @click="handleBackFn">{{ t('首页') }}</el-link>
      </div>
      <el-form
        ref="passwordForm"
        :model="formData"
        :rules="rules"
        class="form"
        @submit.prevent="handleSubmitFn"
      >
        <el-form-item prop="account">
          <el-input
            size="large"
            v-model="formData.account"
            :placeholder=" t('手机号用户名邮箱')  "
            prefix-icon="User"
          />
        </el-form-item>
        <el-form-item prop="oldPassword">
          <el-input
            size="large"
            v-model="formData.oldPassword"
            :placeholder=" t('请输入旧密码')  "
            prefix-icon="Lock"
            type="password"
          />
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input
            size="large"
            v-model="formData.newPassword"
            :placeholder="  t('请设置新密码')  "
            prefix-icon="Lock"
            type="password"
          />
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input
            size="large"
            v-model="formData.confirmPassword"
            :placeholder="  t('请确认新密码') "
            prefix-icon="Lock"
            type="password"
          />
        </el-form-item>
        <el-button
          type="primary"
          size="large"
          class="submit-button"
          :loading="isLoadingSubmit"
          :disabled="isLoadingSubmit"
          @click="handleSubmitFn"
        >{{ t('修改密码') }}</el-button>
      </el-form>
    </div>
  </div>
</template>
  
  <script setup>
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
const router = useRouter();
const { t } = useI18n();
const formData = reactive({
  account: "",
  oldPassword: "",
  newPassword: "",
  confirmPassword: ""
});
// 表单验证规则
const rules = reactive({
  oldPassword: [
    { required: true, message: t("旧密码不能为空"), trigger: "blur" }
  ],
  newPassword: [
    { required: true, message: t("新密码不能为空"), trigger: "blur" },
    { min: 6, max: 20, message: t("新密码长度6 - 20位"), trigger: "blur" }
  ],
  confirmPassword: [
    { required: true, message: t("确认密码不能为空"), trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (value === formData.newPassword) {
          callback();
        } else {
          callback(new Error(t("两次输入的密码不一致")));
        }
      },
      trigger: "blur"
    }
  ]
});
const isLoadingSubmit = ref(false);
const handleSubmitFn = () => {
  isLoadingSubmit.value = true;
  // 这里应该调用修改密码的接口，示例中用 setTimeout 模拟
  setTimeout(() => {
    ElMessage.success(t("密码修改成功"));
    isLoadingSubmit.value = false;
    router.push("/");
  }, 1500);
};
const handleBackFn = () => {
  router.push("/");
};
</script>
  <style lang="scss">
.register-page-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url("@/assets/img/login.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: bgScroll 60s linear infinite;
}

@keyframes bgScroll {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.register-form-container {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 3rem;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 400px;
  z-index: 1;

  .title {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .link-container {
    margin-bottom: 1.5rem;
    text-align: right;
    font-size: 0.9rem;
  }

  .form {
    width: 100%;

    .el-form-item {
      margin-bottom: 1rem;
    }
  }

  .submit-button {
    width: 100%;
  }
}
</style>